import React, { useState, useEffect } from "react";
import { Row, Col, Space, Card } from "antd";
import { List, Button, Toast, NavBar } from "antd-mobile";
import { useHistory, useLocation } from "react-router-dom";
import ajaxService from "../services/ajax-service";
import { withLocalize } from "react-localize-redux";
import { AntOutline, RightOutline } from "antd-mobile-icons";
import Layout from "../layout";
import { masalik } from "../constants";

const Masajid = ({ translate, activeLanguage }) => {
  const history = useHistory();
  const { state } = useLocation();

  const [masajid, setMasajid] = useState([]);

  useEffect(() => {
    setMasajid(state.data);
  }, []);

  const viewDetail = (masjid) => {
    history.push({ pathname: "/masjid/" + masjid.id });
  };

  const maslakMap = {
    0: "any",
    1: "deobandi",
    2: "ahlehadees",
    3: "barelvi",
  };

  return (
    <Layout>
      <div
        style={{
          marginLeft: "30px",
          marginRight: "30px",
          height: "calc(100vh - 100px)",
          overflowY: "auto",
          backgroundColor: "transparent",
          paddingRight: "10px",
        }}
      >
        <Space size="middle" direction="vertical" style={{ width: "100%" }}>
          {masajid.map((masjid, index) => {
            const maslakKey = masalik[masjid.maslak];
            const maslakText = maslakKey ? translate(maslakKey) || "N/A" : "N/A";
            return (
              <List mode="card" key={`masjid-${index}`}>
                <List.Item>
                  <div style={{ display: "flex", justifyContent: "start" }}>
                    <span>
                      {activeLanguage.code === "en"
                        ? masjid.name
                        : masjid.name_ur}
                    </span>
                  </div>
                </List.Item>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>{translate(masjid.namaz)}</span>
                    <span>{masjid.jamat}</span>
                  </div>
                </List.Item>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>
                      {maslakMap[masjid.maslak] ? translate(maslakMap[masjid.maslak]) : "N/A"}
                    </span>
                    <span>{maslakText}</span>

                  </div>
                </List.Item>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>{translate("contact")}</span>
                    <span>{masjid.phone}</span>
                  </div>
                </List.Item>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span></span>
                    <Button color="primary" onClick={() => viewDetail(masjid)}>
                      {translate("details")}
                    </Button>
                  </div>
                </List.Item>
              </List>
            );
          })}
        </Space>
      </div>
    </Layout>
  );
};

export default withLocalize(Masajid);
